import type { CSSProperties, MouseEvent, ReactNode } from "react";
import { Link as RrLink } from "react-router-dom";

type AppLinkProps = {
  href: string;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  target?: string;
  rel?: string;
  replace?: boolean;
};

/**
 * In-app link adapter: `href` maps to React Router `to`.
 * Absolute http(s)/mailto and target=_blank stay as native anchors.
 */
export default function AppLink({
  href,
  children,
  className,
  style,
  onClick,
  target,
  rel,
  replace,
}: AppLinkProps) {
  const external =
    /^https?:\/\//i.test(href) ||
    href.startsWith("mailto:") ||
    target === "_blank";
  if (external) {
    return (
      <a
        href={href}
        className={className}
        style={style}
        onClick={onClick}
        target={target}
        rel={rel ?? (target === "_blank" ? "noopener noreferrer" : undefined)}
      >
        {children}
      </a>
    );
  }
  return (
    <RrLink
      to={href}
      className={className}
      style={style}
      onClick={onClick}
      replace={replace}
    >
      {children}
    </RrLink>
  );
}
